module.exports = __webpack_public_path__ + "static/media/1022704.a238f3f6.jpg";